import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody2, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { NumberingList } from '../TitleList';
import { selectNumberingInwardDatalist } from '../Selectors/TrackSelector/TrackSelector';
import { fetchNumberingInwardList } from '../../Store/PHPSlice/Numbering/numberingApi';


const NumberingInwardRegister = () => {
    const dispatch = useDispatch();
    const numdatalist = useSelector(selectNumberingInwardDatalist);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        dispatch(fetchNumberingInwardList());
    }, [dispatch]);

    // console.log("Original numdatalist:", numdatalist);

    const compData = Array.isArray(numdatalist.data2) ? numdatalist.data2.map((item, index) => (
        {
            serialNumber: index + 1,
            srno: item.ID,
            dt: item.dt,
            numMemo: item.numMemo,
            numInwMemo: item.ctMemo,
            empTypeNm: item.empType,
            empType: item.empType,
            empNm: item.empNm,
            issqty: item.numIssQty,
            reqty: item.return_qty,
            sts: item.sts,
            nId: item.nId,
            firmId: item?.firmId,
            firmNm: item?.firmNm
        }
    )) : [];

    // console.log("Mapped compData:", compData);
    // console.log("compData length:", compData.length);




    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };
    const handleChangeCPage = (n) => {
        setCurrentPage(n);
    };
    const handlePrevPage = () => {
        if (currentPage !== firstIndex) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextpage = () => {
        if (currentPage !== lastIndex) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleRecordsPerPageChange = (event) => {

        setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
        setCurrentPage(0); // Reset current page when records per page changes
    };

    const totalCount = compData ? compData.length : 0;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item.dt.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.numMemoNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.masterNm.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const renderPaginationButtons = () => {
        let start = Math.max(0, currentPage - 10);
        let end = Math.min(npages, start + 9);

        if (end - start < 9) {
            start = Math.max(1, end - 9);
        }

        return numbers.slice(start - 1, end).map((n) => (

            <button key={n} className={`page-link ${currentPage === n ? 'active' : ''}`} onClick={() => handleChangeCPage(n)}>{n}</button>
        ));
    };

    const handleFilterByName = (event) => {
        setPage(0);
        let value = event.target.value.trim();
        setFilterName(event.target.value);

    };
    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    // const notFound = !dataFiltered.length;
    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    //     // Step 2: Debug displayedData
    // console.log("displayedData:", displayedData);
    // console.log("displayedData length:", displayedData.length);

    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };


    return (
        <>
            <Titlebar data={NumberingList} />

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Numbering Inward Register</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>


                            {/* <SearchTable handleRecordsPerPageChange={handleRecordsPerPageChange}
                                filterName={filterName}
                                handleFilterByName={handleFilterByName} /> */}

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                            />


                            <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
                                <Table>
                                    <TableHeader
                                        headCells={
                                            [
                                                { id: 'srno', label: 'SrNo' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'firmNm', label: 'Firm' },
                                                // { id: 'numMemoNo', label: 'Cutting Memo' },
                                                { id: 'cutMemoNo', label: 'Numbering Memo' },
                                                // { id: 'empTypeNm', label: 'Employee Type' },
                                                { id: 'masterNm', label: 'Master' },
                                                { id: 'issqty', label: 'Issue Qty.' },
                                                { id: 'reqty', label: 'Return Qty.' },
                                                { id: 'view', label: 'View' },
                                                // { id: 'inward', label: 'Inward' },
                                                { id: 'delete', label: 'Delete' }

                                            ]
                                        }
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleSort}
                                        numSelected={selected.length}
                                        rowCount={compData.length}
                                        onSelectAllClick={handleSelectAllClick}
                                    />
                                    <tbody>

                                        {displayedData.map((row) => (
                                            <TableBody2
                                                key={row.srno}
                                                id={row.srno}
                                                dt={row.dt}
                                                numMemo={row.numMemo}
                                                numInwMemo={row.numInwMemo}
                                                empType={row.empType}
                                                empNm={row.empNm}
                                                sts={row.sts}
                                                issqty={row.issqty}
                                                reqty={row.reqty}
                                                nId={row.nId}
                                                firmId={row.firmId}
                                                firmNm={row.firmNm}
                                                serialNumber={row.serialNumber}
                                                selected={selected.indexOf(row.name) !== -1}
                                                handleClick={(event) => handleClick(event, row.name)}
                                            />

                                        ))}

                                    </tbody>
                                </Table>
                            </TableContainer>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default NumberingInwardRegister;
